import React, { useRef, useEffect, useState } from "react";
import axios from "axios";
import "./About.css";

const About = () => {
  const imageRef = useRef(null);
  const [aboutList, setAboutList] = useState([]);
  const BASE_URL = "";
   const [folders, setFolders] = useState([]);
    const [ungroupedImages, setUngroupedImages] = useState([]);
    const [activeTab, setActiveTab] = useState("all");
    const [lightboxImages, setLightboxImages] = useState([]);
    const [selectedIndex, setSelectedIndex] = useState(null);

  // 3D hover effect for main banner image
  useEffect(() => {
    const img = imageRef.current;
    if (!img) return;

    const handleMove = (e) => {
      const { left, top, width, height } = img.getBoundingClientRect();
      const x = e.clientX - left - width / 2;
      const y = e.clientY - top - height / 2;
      img.style.transform = `rotateX(${y / 25}deg) rotateY(${x / 25}deg) scale(1.05)`;
    };

    const handleLeave = () => {
      img.style.transform = "rotateX(0) rotateY(0) scale(1)";
    };

    img.addEventListener("mousemove", handleMove);
    img.addEventListener("mouseleave", handleLeave);

    return () => {
      img.removeEventListener("mousemove", handleMove);
      img.removeEventListener("mouseleave", handleLeave);
    };
  }, []);

  // Fetch employee/about data
  useEffect(() => {
    const fetchAboutData = async () => {
      try {
        const res = await axios.get(`${BASE_URL}/api/about`);
        setAboutList(res.data);
      } catch (err) {
        console.error("Error fetching about data", err);
      }
    };
    fetchAboutData();
  }, []);
    useEffect(() => {
    axios
      .get("/api/gallery")
      .then((res) => {
        const namedFolders = [];
        const others = [];

        res.data.folders.forEach((folder) => {
          if (!folder.name || folder.name.trim() === "") {
            others.push(...folder.images);
          } else {
            namedFolders.push(folder);
          }
        });

        setFolders(namedFolders);
        setUngroupedImages([...others, ...res.data.ungroupedImages]);
      })
      .catch((err) => console.error("Fetch error", err));
  }, []);

  const getAllImages = () => {
    const folderImages = folders.flatMap((folder) =>
      folder.images.map((img) => ({ ...img, folderName: folder.name }))
    );
    const ungrouped = ungroupedImages.map((img) => ({
      ...img,
      folderName: "Others",
    }));
    return [...folderImages, ...ungrouped];
  };

  const getCurrentImages = () => {
    if (activeTab === "all") {
      return getAllImages();
    }
    const folder = folders.find((f) => f._id === activeTab);
    return folder
      ? folder.images.map((img) => ({
          ...img,
          folderName: folder.name,
        }))
      : [];
  };

  const openLightbox = (imgList, index) => {
    setLightboxImages(imgList);
    setSelectedIndex(index);
  };

  const closeLightbox = () => setSelectedIndex(null);
  const prevImage = () =>
    setSelectedIndex((prev) =>
      prev > 0 ? prev - 1 : lightboxImages.length - 1
    );
  const nextImage = () =>
    setSelectedIndex((prev) =>
      prev < lightboxImages.length - 1 ? prev + 1 : 0
    );
 const currentImages = getCurrentImages();

  return (
    <> <div
        className="jumbotron jumbotron-fluid page-header position-relative overlay-bottom"
      
      >
        <div className="container text-center py-5" style={{ marginTop: "-80px" }}>
          <h1 className="text-white display-1">About</h1>
          <div className="d-inline-flex text-white mb-5">
            <p className="m-0 text-uppercase">
              <a className="text-white" href="">Home</a>
            </p>
            <i className="fa fa-angle-double-right pt-1 px-3"></i>
            <p className="m-0 text-uppercase">About</p>
          </div>

         
        </div>
      </div>
    <div
      className="container-fluid py-5"
      style={{
        width: "100vw",
        marginLeft: "calc(-50vw + 50%)",
        paddingLeft: "5vw",
        paddingRight: "5vw",
      }}
    >
      

      {/* ABOUT US SECTION */}
       <div className="container-fluid py-5"
        style={{
         
          width: "100vw",
          marginLeft: "calc(-50vw + 50%)",
          paddingLeft: "5vw",
          paddingRight: "5vw",
        }}
      >
        <div className="row gx-0">
          <div className="col-lg-5 mb-5 mb-lg-0" style={{ minHeight: "500px" }}>
  <div className="position-relative h-100" ref={imageRef} style={{ perspective: "1000px" }}>
   <img
  className="w-100 h-100 img-fluid"
  src="/assets/img/powerpressmachine.jpg"
  style={{
    objectFit: "cover", // better for responsive image
    transition: "transform 0.1s ease-out",
    transformStyle: "preserve-3d",
  }}
  alt="About"
/>

  </div>
</div>
<div className="col-lg-7 px-5">
  <div className="section-title position-relative mb-4">
    <h6 className="d-inline-block position-relative text-secondary text-uppercase pb-2">About Us</h6>
    <h1 className="display-4">Welcome to RAMESH ENTERPRISES</h1>
  </div>

  <p>
    Ramesh Enterprises brings decades of expertise in welding solutions, tool manufacturing, and hydraulic press components, 
    serving diverse engineering industries with reliable and high-performance products.
  </p>

  <p><strong>We specialize in:</strong></p>
  <ul className="fs-5 text-justify mb-4 ps-4">
    <li> Hydraulic Press Components & Assemblies</li>
    <li> Tool & Die Manufacturing</li>
    <li> TIG / CO₂ Welding Solutions</li>
    <li> Fabrication & Heavy Welding Jobs</li>
    <li> Precision Machining Support for Press & Welding Applications</li>
  </ul>

  <p>
    With a strong focus on quality, durability, and innovation, Ramesh Enterprises has built long-standing partnerships with 
    leading OEMs and engineering companies. Our solutions ensure strength, reliability, and productivity for critical industrial applications.
  </p>

  <h5 className="fw-bold text-orange mb-3">Our Strengths</h5>
  <ul className="fs-5 text-justify mb-4 ps-4">
    <li> Complete In-House Tooling, Welding & Press Component Manufacturing</li>
    <li> Robust Hydraulic Press & Welding Infrastructure</li>
    <li> Commitment to On-Time Delivery & Quality Assurance</li>
    <li> ISO Certified Quality & Skilled Workforce</li>
  </ul>
</div>

        </div>
      </div>

      {/* MISSION & VISION */}
    <div className="container py-5">
  <div className="text-center mb-5">
    <h2 className="mission-heading">
      Our Mission, Vision & Values
    </h2>
  </div>

  <div className="px-md-5">
    {/* Vision */}
    <h5 className="fw-bold text-orange mb-3">🌐 Our Vision</h5>
    <p className="fs-5 text-justify mb-4">
      To be a one-stop manufacturing solutions provider, delivering welding, tool press, and hydraulic press products to engineering industries.
    </p>

    {/* Mission */}
    <h5 className="fw-bold text-orange mb-3">🎯 Our Mission</h5>
    <ul className="fs-5 text-justify mb-4 ps-4">
      <li> Embrace advanced technologies to manufacture welding, tool press, and hydraulic press components and assemblies.</li>
      <li> Implement robust systems and processes to ensure quality products, on-time delivery, and competitive pricing.</li>
      <li> Foster an engaged and motivated workforce aligned with organizational goals and values.</li>
    </ul>

    {/* Governing Values */}
    <h5 className="fw-bold text-orange mb-3">💡 Our Governing Values</h5>
    
    <p className="fs-5 fw-bold mb-2">Customer First</p>
    <ul className="fs-5 text-justify mb-4 ps-4">
      <li> Give top priority to customer communication in all forms.</li>
      <li> Listen first, respond later—understanding customer needs before acting.</li>
      <li> Commit to complete customer satisfaction without compromise.</li>
    </ul>

    <p className="fs-5 fw-bold mb-2">Ownership</p>
    <ul className="fs-5 text-justify mb-4 ps-4">
      <li>Use resources—people, money, materials, and machines—efficiently, with zero wastage.</li>
      <li> Take responsibility for learning, duties, and deliverables without reminders.</li>
      <li> Consistently comply with workplace discipline and standards.</li>
    </ul>

    <p className="fs-5 fw-bold mb-2">Continual Improvement</p>
    <ul className="fs-5 text-justify mb-4 ps-4">
      <li> Contribute at least one Kaizen (improvement idea) per month and implement it.</li>
      <li> Create and achieve an annual learning plan for personal and professional growth.</li>
    </ul>
  </div>
</div>

      {/* EMPLOYEE / ABOUT DATA */}
      {/* <div className="container py-5">
        <div className="text-center mb-5">
          <h2 className="mission-heading">Our Team</h2>
          <p className="text-muted">Meet the brilliant minds and skilled workforce behind our success</p>
        </div>
        <div className="row">
          {aboutList.map((a) => (
            <div className="col-md-4 mb-4" key={a._id}>
              <div className="card shadow h-100 text-center p-3">
                <img
                  src={a.image ? `${BASE_URL}/uploads/${a.image}` : "/assets/img/no-image.png"}
                  alt={a.name}
                  className="rounded-circle mx-auto"
                  style={{ width: "120px", height: "120px", objectFit: "cover" }}
                />
                <div className="card-body">
                  <h5 className="card-title">{a.name}</h5>
                  <p className="text-muted">{a.company}</p>
                  <p className="card-text">{a.desc}</p>
                  <small className="text-secondary">
                    {a.month} {a.day}
                  </small>
                </div>
              </div>
            </div>
          ))}
          {aboutList.length === 0 && (
            <p className="text-center text-muted">No team data available</p>
          )}
        </div>
      </div> */}






      
    </div>
     <div className="gallery-wrapper">
       <div
        // className="jumbotron jumbotron-fluid page-header position-relative overlay-bottom"
        style={{ marginBottom: '10px' }}
      >
        <div className="container text-center py-5" style={{ marginTop: "-80px" }}>
          <h1 className="naga1"style={{color:"orangered" }}>Gallery</h1>
          <div className="d-inline-flex text-white mb-5">
            <p className="m-0 text-uppercase">
              <a className="text-black" href="">Home</a>
            </p>
            <i className="fa fa-angle-double-right pt-1 px-3"style={{ color: "black" }}></i>
            <p className="text-black">Gallery</p>
          </div>

          
        </div>
      </div>
    

      {/* Tabs */}
      <div className="category-tabs">
        <button
          className={`category-btn ${activeTab === "all" ? "active" : ""}`}
          onClick={() => setActiveTab("all")}
        >
          All
        </button>
        {folders.map((folder) => (
          <button
            key={folder._id}
            className={`category-btn ${
              activeTab === folder._id ? "active" : ""
            }`}
            onClick={() => setActiveTab(folder._id)}
          >
            {folder.name}
          </button>
        ))}
      </div>

      {/* Images */}
      <div className="image-grid">
        {currentImages.map((img, index) => (
          <div className="image-box flip-card" key={img._id}>
            <div
              className="flip-inner"
              onClick={() => openLightbox(currentImages, index)}
            >
              <div className="flip-front">
                
                <img
                  src={`${img.url}`}
                  alt={`gallery-${index}`}
                />
                <p>{img.text || "No description"}</p>
              </div>
              <div className="flip-back">
                <p>{img.text || "No description"}</p>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Lightbox */}
      {selectedIndex !== null && (
        <div className="lightbox" onClick={closeLightbox}>
          <span className="close">&times;</span>
          <span
            className="nav left"
            onClick={(e) => {
              e.stopPropagation();
              prevImage();
            }}
          >
            &#10094;
          </span>
          <span
            className="nav right"
            onClick={(e) => {
              e.stopPropagation();
              nextImage();
            }}
          >
            &#10095;
          </span>
          <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
            <img
              src={`${lightboxImages[selectedIndex].url}`}
              alt="Large"
            />
            <p>{lightboxImages[selectedIndex].text}</p>
          </div>
        </div>
      )}
    </div>
    </>
  );
};

export default About;
